import { render, staticRenderFns } from "./QrCodeGenerator.vue?vue&type=template&id=5b5172e2&scoped=true"
import script from "./QrCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QrCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QrCodeGenerator.vue?vue&type=style&index=0&id=5b5172e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5172e2",
  null
  
)

export default component.exports